import {endpoint} from "@/utils/api/Conf";
import {SearchFilters} from "@/types/Search";
import {Posts} from "@/types/Post";

export const postsRequest = async (searchFilters?: SearchFilters): Promise<Posts | false> => {
  try {
    let paramsString = ""
    const init: RequestInit = {
      method: "GET",
    }
    if (searchFilters) {
      const paramsStrings: Array<string> = []
      if (searchFilters.search && searchFilters.search !== '') {
        paramsStrings.push(`search=${searchFilters.search}`)
      }
      if (searchFilters.type && searchFilters.type !== '') {
        paramsStrings.push(`type_id=${searchFilters.type}`)
      }
      if (searchFilters.category && searchFilters.category !== '') {
        paramsStrings.push(`category_id=${searchFilters.category}`)
      }
      if (searchFilters.segment && searchFilters.segment !== '') {
        paramsStrings.push(`segment_id=${searchFilters.segment}`)
      }
      if (searchFilters.page && searchFilters.page !== '') {
        paramsStrings.push(`page=${searchFilters.page}`)
      }
      if (searchFilters.page_size && searchFilters.page_size !== '') {
        paramsStrings.push(`page_size=${searchFilters.page_size}`)
      }
      if (paramsStrings.length > 0) {
        paramsString = '?' + paramsStrings.join('&')
      }
    }
    return await fetch(endpoint + `posts` + paramsString, init)
      .then((response) => response.json())
      .then((data: Posts) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
